import { Spinner } from '@frontend/elements';
import { FormattedMessage } from 'react-intl';

import { welcome } from '../../utils/kiosk-messages';
import { DefaultHome } from '../default-home/default-home.component';
import SignInCta from '../sign-in-cta/sign-in-cta.component';
import useCarousel from './carousel.controller';

const ID = 'carousel-component';

export const Carousel = () => {
    const viewProps = useCarousel();
    const handlePointerDown = () => {
        viewProps.interruptCarousel();
    };

    if (viewProps.isInterrupted) return <DefaultHome />;

    if (!viewProps.playlistId) {
        return (
            <div
                id={ID}
                className='text-background-surface flex h-full w-full flex-col items-center justify-center gap-2'>
                <span className='text-2xl font-semibold'>
                    <FormattedMessage
                        id='kiosk.home.carousel.no-playlist'
                        defaultMessage='No playlist available'
                    />
                </span>
                <span className='text-base'>
                    <FormattedMessage
                        id='kiosk.home.carousel.no-playlist-description'
                        defaultMessage='Please update your distriSPOT settings'
                    />
                </span>
            </div>
        );
    }
    return (
        <div
            className='flex size-full flex-col items-center justify-between self-stretch'
            onPointerDown={handlePointerDown}>
            <div className='flex size-full flex-col gap-4'>
                <p className='text-background-surface shrink-0 text-sm font-semibold'>
                    {welcome()} {viewProps.display}
                </p>
                <div
                    id={ID}
                    className='flex h-64 w-full items-center justify-center'>
                    {viewProps.url ? (
                        <img
                            className='size-full object-contain'
                            src={viewProps.url}
                            alt={viewProps.url}
                        />
                    ) : (
                        <Spinner />
                    )}
                </div>
            </div>
            {viewProps.allowUserIdentification && !viewProps.isLoggedIn && <SignInCta iconSize='small' />}
        </div>
    );
};

export default Carousel;
